import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AdminSidebarWrapper } from "./styled";
import { Box, LazyImage, SpanStyled } from "../../styled/Elements";
import { ArrowDown, ArrowUp, Cancel, LogoAr, LogoEn } from "../../styled/AllImages";
import { SidebarList } from "../../../helpers/adminConstants/AdminConstants";
import { getModuleOperations } from "../../../utils";
import { useUser } from "../../../context/userContext";
const AdminSidebar = ({ sidebarStatus, setSidebarStatus }) => {
  const location = useLocation();
  const sidebarRef = useRef();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { user } = useUser();
  const [activeSubMenu, setActiveSubMenu] = useState();
  const [filteredSidebarList, setFilteredSidebarList] = useState(SidebarList);
  const handleSubMenuToggle = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };
  const handleMenuItemClick = (index) => {
    setActiveSubMenu(null);
  };

  useEffect(() => {
    if (!user) return;

    const userType = Number(user.user_type_id);

    // For user type 2 → full sidebar
    let filteredList = [];
    if (userType === 2) {
      filteredList = SidebarList;
    } else {
      filteredList = SidebarList.map((mainRoute) => {
        // Remove org-structure if not temporary admin director
        if (
          mainRoute.url === "billing" ||
          (mainRoute.url.includes("settings") &&
            !user.is_temporary_admin_director)
        ) {
          return null;
        }

        // Check permissions
        if (mainRoute.permission) {
          const hasPermission = getModuleOperations(
            mainRoute.permission.collection,
            mainRoute.permission.action
          );
          return hasPermission ? mainRoute : null;
        }

        return mainRoute;
      }).filter(Boolean);
    }

    setFilteredSidebarList(filteredList);
  }, [user]);

  return (
    <>
      <AdminSidebarWrapper
        className={`SideBar ${sidebarStatus ? "open" : "close"}`}
        ref={sidebarRef}
      >
        <Box className="text-center">
          <Box className="logo-container d-flex justify-content-between">
            <LazyImage src={language === "en" ? LogoEn : LogoAr} />

            <button
              className="border-0 bg-transparent p-0"
              onClick={() => setSidebarStatus(false)}
            >
              <Cancel className="close d-lg-none d-block" />
            </button>
          </Box>
          <Box className="border-seprator"></Box>
          <Box className="sidebar-list custom-scroll">
            <ul className="list-unstyled mb-0 pt-3">
              {filteredSidebarList.map((item, key) => {
                // const isSubmenuActive = item.submenu && item.submenu.some(subitem => location.pathname.includes(subitem.url));
                const active = location.pathname.includes(item.url)
                  ? "active"
                  : "";
                // const hasSubMenu = item.submenu && item.submenu.length > 0;

                const hasSubMenu = item.submenu && item.submenu.length > 0;

                // Check if the current URL matches the parent menu or any of the submenu items
                const isSubmenuActive =
                  item.submenu &&
                  item.submenu.some((subitem) =>
                    location.pathname.includes(subitem.url)
                  );
                const isParentActive =
                  location.pathname.includes(item.url) || isSubmenuActive;

                // Add active class to parent li if the submenu is active or the parent item is active
                const activeClass = isParentActive ? "active" : "";

                return (
                  // <li key={item.title + key} className="mb-2">
                  <li key={item.title + key} className="mb-2">
                    <Link
                      id={item.title}
                      to={item.url}
                      // className={`text-decoration-none d-flex align-items-center ${activeClass} ${active}`}
                      className={`text-decoration-none d-flex align-items-center ${
                        hasSubMenu && activeSubMenu === key ? "active" : ""
                      } ${activeClass} ${active}`} //Keep Active on Click Submenu
                      onClick={() => {
                        handleMenuItemClick(key);
                        hasSubMenu && handleSubMenuToggle(key);
                        !hasSubMenu && setSidebarStatus(false);
                      }}
                    >
                      <Box className="list-icon mx-2">
                        <item.icon />
                      </Box>
                      <Box>
                        <SpanStyled
                          className="text-capitalize d-flex"
                          style={{ textAlign: "start" }}
                        >
                          {t(item.title)}
                        </SpanStyled>
                      </Box>
                      {hasSubMenu &&
                        !["users", "temporary-users"].includes(item?.url) && (
                          <Box className="ms-auto subArrow">
                            {activeSubMenu === key ? (
                              <ArrowDown />
                            ) : (
                              <ArrowUp />
                            )}
                          </Box>
                        )}
                    </Link>
                    {hasSubMenu && activeSubMenu === key && (
                      <ul className="subMenu p-0">
                        {item.submenu.map((subitem, subkey) => {
                          return (
                            <li key={subitem.title + subkey}>
                              <Link
                                id={subitem.title}
                                to={subitem.url}
                                className={`text-decoration-none w-100 d-block ${
                                  location.pathname === `/${subitem.url}` &&
                                  "subActive"
                                  // location.pathname.includes(subitem.url) &&
                                  // "subActive"
                                }`}
                                // onClick={() => setSidebarStatus(false)}
                              >
                                {t(subitem.title)}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </Box>
        </Box>
      </AdminSidebarWrapper>
    </>
  );
};

export default AdminSidebar;
